import { render, staticRenderFns } from "./formPinterest.vue?vue&type=template&id=625fbb7c&"
import script from "./formPinterest.vue?vue&type=script&lang=js&"
export * from "./formPinterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports